import { Col, Form, FormInstance, Row, Space } from 'antd';
import React, { PropsWithChildren, useState } from 'react';
import { Button } from '@maxtropy/components';

export interface FilterProps<T> {
  onFinish: (val: object) => void;
  children?: React.ReactNode;
  initialValues?: T;
  onReset?: () => void;
  form: FormInstance;
  collapseItems?: React.ReactNode;
}

function Filter<T>(props: PropsWithChildren<FilterProps<T>>): React.ReactElement {
  const { onFinish, onReset, children, initialValues, form, collapseItems } = props;

  const _onReset = () => {
    onReset && onReset();
    form.resetFields();
  };

  const [open, setOpen] = useState(false);

  return (
    <Form
      name="customized_form_controls"
      form={form}
      // layout="inline"
      onFinish={onFinish}
      initialValues={initialValues}
      // className={styles.filter}
    >
      <Row gutter={20} style={{ marginTop: 15 }}>
        {children}
        {open && collapseItems}
        <Col
          span={4}
          style={{
            marginRight: 0,
            minWidth: 150,
            display: 'flex',
            flexDirection: 'row-reverse',
            marginLeft: 'auto',
          }}
        >
          <Form.Item>
            <Space size={12}>
              {collapseItems && (
                <Button type="link" onClick={() => setOpen(!open)}>
                  {open ? '收起' : '展开'}
                </Button>
              )}
              <Button type="primary" htmlType="submit">
                查询
              </Button>
              <Button onClick={_onReset}>重置</Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}

export default Filter;
